import { EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcPaginatorComponent = /** @class */ (function () {
    function FcPaginatorComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.pageSize = 50;
        this.pageIndex = 0;
        this.currentPageLength = 0;
        this.isLoading = false;
        this.page = new EventEmitter();
        this.isFirstPage = false;
        this.isLastPage = false;
        this.from = 0;
        this.until = 0;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcPaginatorComponent.prototype.ngOnInit = function () {
        this.updateState();
    };
    FcPaginatorComponent.prototype.ngOnChanges = function (_changes) {
        this.updateState();
    };
    FcPaginatorComponent.prototype.nextPage = function () {
        var previousPageIndex = this.pageIndex;
        this.pageIndex++;
        this.page.emit({
            length: this.totalCount,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            previousPageIndex: previousPageIndex
        });
        this.updateState();
    };
    FcPaginatorComponent.prototype.previousPage = function () {
        var previousPageIndex = this.pageIndex;
        this.pageIndex--;
        this.page.emit({
            length: this.totalCount,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            previousPageIndex: previousPageIndex
        });
        this.updateState();
    };
    FcPaginatorComponent.prototype.firstPage = function () {
        var previousPageIndex = this.pageIndex;
        this.pageIndex = 0;
        this.page.emit({
            length: this.totalCount,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            previousPageIndex: previousPageIndex
        });
        this.updateState();
    };
    FcPaginatorComponent.prototype.updateState = function () {
        this.isFirstPage = this.pageIndex <= 0;
        this.isLastPage = this.pageIndex + 1 >= Math.ceil(this.totalCount / this.pageSize) || this.currentPageLength < this.pageSize;
        this.from = this.pageIndex * this.pageSize + 1;
        this.until = this.isLastPage ? (this.from + this.currentPageLength - 1) : (this.pageIndex + 1) * this.pageSize;
    };
    return FcPaginatorComponent;
}());
export { FcPaginatorComponent };
